// extracted by mini-css-extract-plugin
export default {"root":"About__root--DRzO6","container":"About__container--OrYeU","heading":"About__heading--w2vy4"};